
import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

const Footer = () => {
  return (
    <footer className="bg-patrimoine-dark text-white py-4">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} LA PATRIMONIALE Gestion. Tous droits réservés.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/mentions-legales" className="hover:text-white">Mentions Légales</Link>
            <Link to="/confidentialite" className="hover:text-white">Politique de Confidentialité</Link>
            <Link to="/cgv" className="hover:text-white">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
